import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const distanceCategoriesAdapter = getAdapter({ idFieldName: 'value' });

const distanceCategoriesSlice = createSlice({
  name: 'distanceCategories',
  initialState: distanceCategoriesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setDistanceCategories: (state, { payload: { distanceCategories, source } }) => {
      distanceCategoriesAdapter.setAll(state, distanceCategories);
      state.source = source;
    }
  }
});

const selectors = distanceCategoriesAdapter.getSelectors(({ distanceCategories }) => distanceCategories);

export const getDistanceCategories = state => selectors.selectAll(state);

export const { setDistanceCategories } = distanceCategoriesSlice.actions;

export default distanceCategoriesSlice.reducer;
